import { REPORT_ENDPOINT } from '../../../../../api/endpoint';
export const DAILY_REPORT_ENDPOINT = `${REPORT_ENDPOINT}/daily_report`;
